import { messages } from './messages'
import { messages_pt } from './translations/pt'

export const intlMessages: { [locale: string]: any } = {
  pt: messages_pt,
}

export const createdDefaultMessages = Object.entries(messages).reduce((acc, [key, value]) => {
  return { ...acc, [value]: { defaultMessage: value, id: key } }
}, {} as { [id: string]: ReactIntl.FormattedMessage.MessageDescriptor })
